import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';

import type {SourceFragment as Source} from 'nutshell-graphql-types';

import {ChannelSourceRowSelectState} from './channel-source-row-select-state';
import {SourceRowReadState} from './source-row-read-state';

type Props = {
    sources: Source[];
    sourceOptions: Source[];
    isAddingChannelSource: boolean;
    canAccessSetup: boolean;
    onRemoveSource: (sourceId: string) => void;
    onSelectSource: (sourceId: string) => void;
    onCancel: () => void;
};

export function ChannelRowReadState(props: Props) {
    if (props.sources.length === 0 && !props.isAddingChannelSource) {
        return null;
    }

    return (
        <div className='mt-8'>
            <Stack spacing={4}>
                {props.sources.length > 0 &&
                    props.sources.map((source) => {
                        return (
                            <SourceRowReadState
                                key={source.id}
                                id={source.id}
                                name={source.name}
                                onRemoveSource={props.onRemoveSource}
                                hasHorizontalMargin={false}
                            />
                        );
                    })}
                {props.isAddingChannelSource && (
                    <ChannelSourceRowSelectState
                        creatableState='source'
                        onSelectChannel={() => {}}
                        existingChannels={[]}
                        canAccessSetup={props.canAccessSetup}
                        sourceOptions={props.sourceOptions}
                        onSelectSource={props.onSelectSource}
                        onCancel={props.onCancel}
                    />
                )}
            </Stack>
        </div>
    );
}
